<style scoped lang="stylus">
.layout {
    @import "../../assets/css/theme.styl"
    height 100vh
    //background linear-gradient(to bottom, #080c0f , #24282b);
    background-color baseBackColor
}
</style>

<template>
    <div class="layout" data-flex="dir:top">
        <!--java拦截成本地文件,域名不要修改-->
        <RemoteJs src="https://injection/www/cordova.js" :call-back="cordovaLoad" />

        <CusNav />
        <router-view v-wechat-title="$route.meta.title" style="flex: 1;overflow: auto" />
        <CusTab v-show="meta.hideBack" />
    </div>
</template>

<script>
import _ from 'lodash';
import { info } from '@/service/user';
import RemoteJs from '@/components/RemoteJs';
import { DEV, SYS_START_DATE } from '@/config';
import CusNav from '@/components/CusNav';
import CusTab from '@/components/CusTabbar';
import { getInfo } from '@/service/app';
import { versionCheck } from '@/util';
import { Dialog } from 'vant';
import dayjs from 'dayjs';
export default {
    props: {},
    components: {
        CusNav,
        CusTab,
        RemoteJs,
    },
    data() {
        return {
            dev: DEV,
            localVersion: '', //本地版本
            newVersion: '', //最新版本
            reqData: {}, //请求版本信息数据
        };
    },
    created() {},
    mounted() {
        this.init();
        this.getData();
        // this.expTip();
    },
    computed: {
        meta() {
            return this.$route.meta;
        },
    },
    watch: {},
    methods: {
        getData() {},

        init() {
            document.addEventListener(
                'deviceready',
                async () => {
                    this.getLocalVersion();
                },
                false,
            );
        },
        async getLocalVersion() {
            //获取app版本号提示升级
            let version = await cordova.getAppVersion.getVersionNumber();
            this.localVersion = version;
            // this.getNewVersion();
        },
        async getNewVersion() {
            let res = await getInfo();
            if (res.status) {
                this.newVersion = res.data.version;
                this.reqData = res.data;
                this.checkUpdate();
            }
        },
        async checkUpdate() {
            if (versionCheck(this.localVersion, this.newVersion)) {
                this.showConfirmUpdate();
            } else {
            }
        },
        showConfirmUpdate() {
            //确认更新框框
            this.$dialog
                .confirm({
                    title: '版本更新',
                    message: `有新版本${this.newVersion},是否更新?`,
                })
                .then(() => {
                    //确认
                    // this.$toast('你点了确认')
                    cordova.InAppBrowser.open(this.reqData.download_url, '_system', 'hidden=yes');
                })
                .catch(() => {
                    //取消
                    // this.$toast('你点了取消')
                });
        },

        cordovaLoad() {},
        expTip() {
            setTimeout(() => {
                Dialog.alert({
                    title: '温馨提示',
                    message: `系统已累计服务${dayjs().diff(SYS_START_DATE, 'day')}天，即将到期，届时将无法为您提供服务，请尽快与服务商联系。`,
                }).then(() => {
                    this.expTip();
                });
            }, 10 * 1000);
        },
    },
};
</script>
